import { uploadMyInvestmentProofs } from 'api/home/myPay';
import { asyncThunkWrapper } from 'utils/AsyncThunkWrapper';

const getDocumentsNeedToUpload = asyncThunkWrapper('uploadMyInvestmentProofs/fetch', uploadMyInvestmentProofs);

export { getDocumentsNeedToUpload };
